<template>
  <div class="home">
    <Main msg="Are you similar to Patrick Bateman?" score="53"/>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
// eslint-disable-next-line import/no-unresolved
import Main from '@/components/Main.vue';
// eslint-disable-next-line import/no-unresolved
import Footer from '@/components/Footer.vue';

export default {
  name: 'Home',
  components: {
    Main,
    Footer,
  },
};
</script>
